class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    if (!this.detailsContainer || !this.summaryToggle) {return;}

    // Bind methods
    this.onResize = this.onResize.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onBodyClick = this.onBodyClick.bind(this);

    // Base listeners
    this.detailsContainer.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE" && !this.alwaysOpen) {
        this.close();
      }
    });

    this.summaryToggle.addEventListener("click", this.onSummaryClick);

    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton)
      {closeButton.addEventListener("click", this.close.bind(this));}

    this.summaryToggle.setAttribute("role", "button");

    // Initial mode check
    this.alwaysOpen = false;
    this.checkAlwaysOpenMode();

    // Watch for resize
    window.addEventListener("resize", this.onResize);
  }

  checkAlwaysOpenMode() {
    const shouldBeAlwaysOpen = window.innerWidth >= 990;

    if (shouldBeAlwaysOpen && !this.alwaysOpen) {
      this.alwaysOpen = true;
      this.forceAlwaysOpen();
    } else if (!shouldBeAlwaysOpen && this.alwaysOpen) {
      this.alwaysOpen = false;
      this.disableAlwaysOpen();
    }
  }

  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => this.checkAlwaysOpenMode(), 150);
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    if (this.alwaysOpen) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (this.alwaysOpen) {return;}
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    ) {
      this.close(false);
    }
  }

  open(event) {
    if (this.alwaysOpen) {return;}
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    if (this.alwaysOpen) {return;}
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }

  forceAlwaysOpen() {
    this.detailsContainer.setAttribute("open", true);
    this.classList.add("always-open-active");
    const overlay = this.querySelector(".modal-overlay");
    if (overlay) {overlay.style.display = "none";}
    this.summaryToggle.style.display = "none";
    document.body.classList.remove("overflow-hidden");
  }

  disableAlwaysOpen() {
    this.classList.remove("always-open-active");
    const overlay = this.querySelector(".modal-overlay");
    if (overlay) {overlay.style.display = "";}
    this.summaryToggle.style.display = "";
    this.detailsContainer.removeAttribute("open");
  }
}

customElements.define("details-modal", DetailsModal);
